import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Inpc from 'inpc/components/form';

const InpcFormView = ({
  t,
  inpc,
  company,
  handleSubmit,
  handleValueChange,
  handleValidation,
  isFetching,
  isSubmitted,
  isSaving,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("inpc.inpc_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.control_panel') +
          ' > ' +
          t('inpc.inpc_title') +
          ' > ' +
          t(inpc.id ? 'inpc.edit' : 'inpc.add')
        }
        icon={'archive'}
      >
        <Inpc.Form
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          values={inpc}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(InpcFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/InpcFormView.js